/*
  LIOR - the exchange and return policy pages in the style of iOS 27
  (assets/lior-ios-policy.css; one pair for the full policy, #lior-return-policy,
  and for the two short gateway pages, #lior-policy-gateway).

  The pages are the merchant's own content with their own small script (quick
  links that scroll, a reading bar, sections that rise in), which keeps doing
  all of that. This file only dresses them:
    - the three key terms up front get icon tiles, their numbers set large
    - the paragraphs of a section become rows of one white inset group, each
      led by a tile in the colour of what it is about (timing orange, refund
      blue, exchange purple, delivery green, as everywhere on the site)
    - the product conditions become a checklist: green what is needed, red
      what is not accepted
    - self drop-off and the courier get the pin and truck of the request form,
      and their prices a small capsule
    - links get their glyphs: the request form, WhatsApp, phone and email
    - a "←" at the end of a link stays in the page for its words, hidden from
      screen readers, and a chevron draws it instead
  Words, links and their order stay exactly as they are.
*/
(function () {
  'use strict';

  if (window.__liorIosPolicy) return;
  window.__liorIosPolicy = true;

  var D = document;

  /* Glyphs on the 24-point grid of the iOS menu (snippets/lior-im-icon.liquid) */
  var G = {
    clock: '<circle cx="12" cy="12" r="8.6"/><path d="M12 7.4V12l3.1 2"/>',
    returns: '<path d="M9 7.5 5.5 11 9 14.5"/><path d="M5.5 11h9a4 4 0 0 1 0 8H12"/>',
    exchange: '<path d="M4.6 11.2a7.4 7.4 0 0 1 13-4.6"/><path d="M17.9 3.5v3.4h-3.4"/><path d="M19.4 12.8a7.4 7.4 0 0 1-13 4.6"/><path d="M6.1 20.5v-3.4h3.4"/>',
    truck: '<path d="M3.5 7h10v8.5h-10z"/><path d="M13.5 10h3.6l3.4 3.4v2.1h-7"/><circle cx="7.3" cy="17" r="1.6"/><circle cx="16.8" cy="17" r="1.6"/>',
    pin: '<path d="M12 21s-6.6-5.7-6.6-11.2a6.6 6.6 0 0 1 13.2 0C18.6 15.3 12 21 12 21z"/><circle cx="12" cy="9.8" r="2.4"/>',
    card: '<rect x="3" y="5.6" width="18" height="12.8" rx="2.4"/><path d="M3 9.8h18M6.6 14.6h3.8"/>',
    calendar: '<rect x="4" y="5.6" width="16" height="14.6" rx="2.6"/><path d="M4 10h16M8.4 3.6v3.6M15.6 3.6v3.6"/><path class="lpo-dot" d="M8.6 14h.01M12 14h.01M15.4 14h.01"/>',
    doc: '<path d="M7 3.5h6.5L18 8v12.5H7z"/><path d="M13.5 3.5V8H18M9.8 12.2h5.4M9.8 15.6h5.4"/>',
    compose: '<path d="M11.4 4.6H6.8a2.2 2.2 0 0 0-2.2 2.2v10.4c0 1.2 1 2.2 2.2 2.2h10.4c1.2 0 2.2-1 2.2-2.2v-4.6"/><path d="M17.7 3.7a1.9 1.9 0 0 1 2.6 2.6l-7.4 7.4-3.4.8.8-3.4z"/>',
    chev: '<path d="M9.5 5.5 16 12l-6.5 6.5"/>',
    info: '<circle cx="12" cy="12" r="8.6"/><path d="M12 11v5.4"/><path class="lpo-dot" d="M12 7.8h.01"/>',
    checkc: '<circle class="lpo-fill" cx="12" cy="12" r="9.2"/><path class="lpo-on" d="m8.2 12.3 2.6 2.6 5-5.4"/>',
    xc: '<circle class="lpo-fill" cx="12" cy="12" r="9.2"/><path class="lpo-on" d="m9.3 9.3 5.4 5.4M14.7 9.3l-5.4 5.4"/>',
    phone: '<path d="M7.4 3.8h2.2l1.3 4-1.8 1.3a10.6 10.6 0 0 0 5.8 5.8l1.3-1.8 4 1.3v2.2a2 2 0 0 1-2.1 2A15.6 15.6 0 0 1 5.4 5.9a2 2 0 0 1 2-2.1z"/>',
    mail: '<rect x="3.4" y="5.6" width="17.2" height="12.8" rx="2.6"/><path d="m4.4 7.4 7.6 5.6 7.6-5.6"/>',
    wa: '<path class="lpo-fill" fill-rule="evenodd" d="M12 2.6a9.4 9.4 0 0 0-8.1 14.2L2.6 21.4l4.7-1.2A9.4 9.4 0 1 0 12 2.6zm5.4 13.2c-.2.6-1.3 1.2-1.8 1.3-.5 0-.9.2-3.1-.6-2.6-1-4.3-3.7-4.4-3.9-.1-.2-1-1.4-1-2.7s.7-1.9.9-2.2c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.3 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.3 2.4 1.4.3.2.5.1.6-.1l.9-1.1c.2-.3.4-.2.7-.1l1.8.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/>'
  };

  function ic(name, cls) {
    return '<svg class="lpo-ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (G[name] || G.info) + '</svg>';
  }
  function tile(name, colour) {
    return '<span class="lpo-tile" data-lpo-c="' + colour + '" aria-hidden="true">' + ic(name) + '</span>';
  }

  /* What a paragraph is about, from its words (first match wins) */
  var ROWS = [
    [/48 שעות|להודיע/, 'clock', 'orange'],
    [/לפי החוק|הודעת הביטול/, 'calendar', 'blue'],
    [/אמצעי התשלום|ההחזר הכספי|זיכוי/, 'card', 'blue'],
    [/שליחויות|שליח/, 'truck', 'orange'],
    [/החלפ|המידה|הצבע/, 'exchange', 'purple'],
    [/במלאי|יישלח|משלוח/, 'truck', 'green'],
    [/לשלוח|להגיע|החזר/, 'returns', 'blue']
  ];
  function rowOf(text) {
    for (var i = 0; i < ROWS.length; i++) if (ROWS[i][0].test(text)) return ROWS[i];
    return [null, 'info', 'gray'];
  }

  /* The key terms: hours to tell us, days to send it, the courier's price */
  function statOf(text) {
    if (/שעות|שעה/.test(text)) return ['clock', 'orange'];
    if (/₪|משלוח|שליח/.test(text)) return ['truck', 'orange'];
    if (/ימים|ימי|החזר/.test(text)) return ['returns', 'blue'];
    return ['info', 'gray'];
  }

  var NOT_ACCEPTED = /לא יתקבל|אין /;

  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  function wrapNode(node, cls, hidden) {
    var s = D.createElement('span');
    s.className = cls;
    if (hidden) s.setAttribute('aria-hidden', 'true');
    node.parentNode.replaceChild(s, node);
    s.appendChild(node);
    return s;
  }

  /* Move an element into a new parent with the blank text after it, so the
     page's text keeps exactly its order and spacing */
  function moveWith(el, into) {
    var next = el.nextSibling;
    into.appendChild(el);
    while (next && next.nodeType === 3 && !clean(next.nodeValue)) {
      var after = next.nextSibling;
      into.appendChild(next);
      next = after;
    }
  }

  /* "←" at the end of a link: kept, hidden from screen readers, drawn by a glyph */
  function arrow(a) {
    if (!a || a.querySelector('.lpo-arrow')) return false;
    var tw = D.createTreeWalker(a, 4, null);
    var t;
    var hit = null;
    while ((t = tw.nextNode())) if (t.nodeValue.indexOf('←') !== -1) hit = t;
    if (!hit) return false;
    var mid = hit.splitText(hit.nodeValue.lastIndexOf('←'));
    mid.splitText(1);
    wrapNode(mid, 'lpo-arrow', true);
    return true;
  }

  function prepend(el, html) {
    if (el && !el.querySelector(':scope > .lpo-ic, :scope > .lpo-tile')) el.insertAdjacentHTML('afterbegin', html);
  }
  function append(el, html) {
    if (el && !el.querySelector(':scope > .lpo-chev')) el.insertAdjacentHTML('beforeend', html);
  }

  /* "48 שעות": the number large, the unit beside it */
  function bigNumber(strong) {
    if (!strong || strong.querySelector('.lpo-num')) return;
    if (strong.childNodes.length !== 1 || strong.firstChild.nodeType !== 3) return;
    var t = strong.firstChild;
    var m = /[\d.,]*\d/.exec(t.nodeValue);
    if (!m) return;
    var num = m.index ? t.splitText(m.index) : t;
    var rest = num.splitText(m[0].length);
    wrapNode(num, 'lpo-num');
    var at = rest.nodeValue.search(/\S/);
    if (at === -1) return;
    var unit = at ? rest.splitText(at) : rest;
    wrapNode(unit, 'lpo-unit');
  }

  /* ------------------------------------------------------------------------
     The full policy
     ------------------------------------------------------------------------ */
  function dressPolicy(root) {
    /* the header: the request form as a capsule with its glyph */
    qa(root, '.rp-hero a').forEach(function (a) {
      arrow(a);
      prepend(a, ic('compose'));
    });

    /* the key terms */
    qa(root, '.rp-summary .rp-stat').forEach(function (stat) {
      if (stat.querySelector(':scope > .lpo-tile')) return;
      var k = statOf(clean(stat.textContent));
      stat.insertAdjacentHTML('afterbegin', tile(k[0], k[1]));
      bigNumber(stat.querySelector('strong'));
    });

    qa(root, '.rp-section').forEach(function (section) {
      /* paragraphs in a row become one inset group, a tile on each */
      var group = null;
      Array.prototype.slice.call(section.children).forEach(function (el) {
        if (el.tagName === 'P' && !el.classList.contains('rp-small')) {
          if (!group) {
            group = D.createElement('div');
            group.className = 'lpo-group';
            section.insertBefore(group, el);
          }
          var k = rowOf(clean(el.textContent));
          var row = D.createElement('div');
          row.className = 'lpo-row';
          row.innerHTML = tile(k[1], k[2]);
          group.appendChild(row);
          moveWith(el, row);
          return;
        }
        group = null;
      });

      /* the conditions: a checklist */
      qa(section, ':scope > ul > li').forEach(function (li) {
        if (li.classList.contains('lpo-li')) return;
        var no = NOT_ACCEPTED.test(clean(li.textContent));
        var tx = D.createElement('span');
        tx.className = 'lpo-li__tx';
        while (li.firstChild) tx.appendChild(li.firstChild);
        li.appendChild(tx);
        li.insertAdjacentHTML('afterbegin', ic(no ? 'xc' : 'checkc', 'lpo-mark'));
        li.setAttribute('data-lpo-mark', no ? 'no' : 'ok');
        li.classList.add('lpo-li');
      });

      /* self drop-off and the courier */
      qa(section, '.rp-grid > .rp-card').forEach(function (card) {
        if (card.classList.contains('lpo-card')) return;
        var title = clean((card.querySelector('h3') || card).textContent);
        var k = /עצמאית|הגעה|בת ים/.test(title) ? ['pin', 'green'] :
          /שליח|משלוח/.test(title) ? ['truck', 'orange'] : rowOf(title).slice(1);
        card.insertAdjacentHTML('afterbegin', tile(k[0], k[1]));
        card.classList.add('lpo-card');
        qa(card, ':scope > p').forEach(function (p) {
          var s = p.querySelector(':scope > strong');
          if (!s || p.children.length !== 1 || clean(s.textContent) !== clean(p.textContent)) return;
          p.classList.add('lpo-price');
          p.setAttribute('data-lpo-price', /ללא עלות|חינם/.test(s.textContent) ? 'free' : 'paid');
        });
      });
    });

    /* ready to open a request: a chevron for the "←" */
    qa(root, '.rp-cta a').forEach(function (a) {
      if (arrow(a)) append(a, ic('chev', 'lpo-chev'));
    });

    /* WhatsApp, phone, email */
    qa(root, 'footer a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (/wa\.me|whatsapp/i.test(href)) prepend(a, ic('wa'));
      else if (/^tel:/i.test(href)) prepend(a, ic('phone'));
      else if (/^mailto:/i.test(href)) prepend(a, ic('mail'));
    });
  }

  /* ------------------------------------------------------------------------
     The short pages that lead to it
     ------------------------------------------------------------------------ */
  function dressGateway(root) {
    qa(root, ':scope > a').forEach(function (a) {
      arrow(a);
      prepend(a, tile('doc', 'blue'));
      append(a, ic('chev', 'lpo-chev'));
    });
    qa(root, ':scope > a + p > a').forEach(function (a) {
      arrow(a);
      append(a, ic('chev', 'lpo-chev'));
    });
  }

  function dress(root, fn) {
    if (root.hasAttribute('data-lpo')) return;
    root.setAttribute('data-lpo', '');
    try {
      fn(root);
    } catch (err) {
      /* the merchant's page stays as it is, styled by the stylesheet alone */
      if (window.console && console.warn) console.warn('[lior-ios-policy]', err);
    }
  }

  function boot() {
    qa(D, '.lpg--policy #lior-return-policy').forEach(function (r) { dress(r, dressPolicy); });
    qa(D, '.lpg--policy #lior-policy-gateway').forEach(function (r) { dress(r, dressGateway); });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  D.addEventListener('shopify:section:load', boot);
  /* iOS Safari shows :active (the press of the capsules and rows) only with a touch listener */
  D.addEventListener('touchstart', function () {}, { passive: true });
})();
